import { render, staticRenderFns } from "./create_package.vue?vue&type=template&id=77c9ac16&scoped=true&"
import script from "./create_package.vue?vue&type=script&lang=js&"
export * from "./create_package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c9ac16",
  null
  
)

export default component.exports